import type { CategoryData } from 'usercentrics-browser-ui/api-interfaces';

type CategoryName = 'Analytics' | 'Marketing' | 'Functional';

export interface ConsentCategoryPreferences {
  readonly analytics: boolean;
  readonly marketing: boolean;
  readonly functional: boolean;
}

function isCategoryAccepted(categories: CategoryData[], name: CategoryName): boolean {
  return categories.find(category => category.name === name)?.state === 'ALL_ACCEPTED';
}

async function getConsentCategories(): Promise<CategoryData[]> {
  try {
    const details = await window.__ucCmp.getConsentDetails();
    const categories = Object.values(details.categories);

    const hasValidCategories = categories.every((category: unknown) => typeof category === 'object' && category !== null &&
      'name' in category && typeof category.name === 'string' &&
      'state' in category && (
      category.state === 'ALL_ACCEPTED' ||
      category.state === 'ALL_DENIED' ||
      category.state === 'SOME_ACCEPTED'
    ));

    return hasValidCategories ? categories : [];
  } catch {
    return [];
  }
}

export async function getConsentCategoryState(categoryName: CategoryName) : Promise<boolean> {
  const categories = await getConsentCategories();

  return isCategoryAccepted(categories, categoryName);
}

export async function getConsentCategoryPreferences(): Promise<ConsentCategoryPreferences> {
  const categories = await getConsentCategories();

  return {
    analytics: isCategoryAccepted(categories, 'Analytics'),
    marketing: isCategoryAccepted(categories, 'Marketing'),
    functional: isCategoryAccepted(categories, 'Functional')
  };
}
